import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { ProviderResponse } from "@/types";

type Props = {
  page?: string | null;
  perPage?: string;
  search?: string;
};

async function fetchProviders({
  page = "1",
  search,
}: Props): Promise<ProviderResponse> {
  const response = await httpRequest.get<ProviderResponse>(
    `/providers?page=${page}&search=${search}`
  );
  return response.data;
}

export function useFetchProvidersQuery(props: Props) {
  const providersQuery = useQuery({
    queryKey: ["providers", props.page || "1", props.search],
    queryFn: () => fetchProviders(props),
    keepPreviousData: true,
  });

  return {
    ...providersQuery,
    data: providersQuery?.data,
  };
}
